<template>
  <div class="tab">
    <h3>CPYDS大事件快讯一览</h3>
    <div v-if="conIsShow">
      <ul>
        <li v-for="(list,index) in FoundList" v-bind:key="index">
          <a href="javascript:;" @click="goDetails(list)">{{list.Theme}}</a>
          <span>{{list.ReleaseTime_toString}}</span>
        </li>
      </ul>
      <Pager
        v-if="!dataChanged"
        @setPage="getData"
        ref="page"
        :pageSize="pageSize"
        :page="page"
        :curPage="curPage"
        :total="total"
      />
    </div>
    <div v-if="!conIsShow">
      <ConDetail :listID="listID" />
    </div>
  </div>
</template>
<script>
import Pager from "../paging/page";
import ConDetail from "./detail";
export default {
  name: "bigEvent",
  data() {
    return {
      curPage: 1, //当前页
      page: 0, //总页数
      total: 0, //总共数
      pageSize: 10, //每页记录数
      dataChanged: true,
      FoundList: [],
      conIsShow: true,
      listID: ""
    };
  },
  components: {
    Pager: Pager,
    ConDetail: ConDetail
  },
  created() {
    this.getData();

    if (location.href.indexOf("ID") != -1) {
      var href = location.href;
      const index = href.lastIndexOf("=");
      href = href.substring(index + 1, href.length);
      var data = {"ID": href}
      this.goDetails(data);
    }
  },

  methods: {
    getData(curPage) {
      this.$axios({
        method: "post",
        url: "https://auth.zkey.cc/api/Notice/GetPublicList",
        headers: {
          "Content-Type": "application/json"
        },
        // withCredentials: true
        data: JSON.stringify({
          offset: curPage,
          limit: this.pageSize,
          Type: "ProjectEvent"
        })
      })
        .then(res => {
          this.FoundList = res.data.list;
          this.page = res.data.count / res.data.list.length;
          this.total = res.data.count;
          this.curPage = curPage ? curPage : this.curPage;
          this.dataChanged = false;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goDetails(data) {
      this.listID = data.ID;
      this.conIsShow = false;
    }
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>


// WEBPACK FOOTER //
// src/components/tabs/bigEvent.vue